import React from 'react';
import { DEFAULT_APP_PRIMARY } from '../utils/branding';

/**
 * Full-screen splash during auth bootstrap (Firebase + Firestore user).
 * Always Crewchain logo + default chrome — company branding applies after the shell mounts.
 */
const AuthLoadingSpinner = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--branding-app-surface)',
      zIndex: 9999,
    }}
  >
    <img
      src="/CrewChain.png"
      alt="Crewchain"
      style={{
        width: '120px',
        height: 'auto',
        marginBottom: '32px',
        opacity: 0.9,
      }}
    />

    <div
      style={{
        width: '48px',
        height: '48px',
        border: '4px solid var(--branding-app-surface-panel-border)',
        borderTop: `4px solid ${DEFAULT_APP_PRIMARY}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}
    />

    <p
      style={{
        marginTop: '24px',
        color: 'var(--cc-text-muted)',
        fontSize: '14px',
        fontWeight: '500',
        letterSpacing: '0.5px',
      }}
    >
      Loading...
    </p>

    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);

export default AuthLoadingSpinner;
